import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import i18n from '../i18n.json'

const formatAmount = (amount, discount, decimals, ceil) => {
  if (ceil) return Math.ceil(amount / (1 - discount)).toFixed(decimals)
  return (amount / (1 - discount)).toFixed(decimals)
}

class LogoDownload extends Component {
  constructor(props) {
    super(props)
    this.state = {
      availableProducts: this.props.availableProducts,
      loading: false
    }
  }

  componentWillMount() {
    this.setState({
      loading: true
    })
    this.callAvailableProducts()
    this.props.authenticateUser()
    .then(() => {
      this.setState({
        loading: false
      })
    })
    .catch((error) => {
      this.setState({
        loading: false
      })
    })
  }

  componentDidUpdate(prevProps, prevState) {
    let prevSelectedLanguage = prevProps.newLogo.userPrefs.selectedLanguage
    let { selectedLanguage } = this.props.newLogo.userPrefs
    if (prevSelectedLanguage !== selectedLanguage) {
      this.callAvailableProducts()
    }
  }

  callAvailableProducts = () => {
    let locale = 'en_US'
    let { selectedLanguage } = this.props.newLogo.userPrefs
    if (selectedLanguage === 'pt') locale = 'pt_BR'
    this.props.getAvailableProducts({locale: locale})
  }

  freePurchase(productID, logoToPurchase) {
    return this.props.performFreePurchase(productID, logoToPurchase)
    .then(res => {
      // Show a success page to the buyer
      if (res.status === 200) {
        window.location.replace("/success")
      }
    })
    .catch(error => {
      // return Promise.reject(error)
    })
  }

  // Called when a buyer clicks the PayPal button
  // Set up a getter to create a Payment ID using the payments api, on server side
  payment(data, productID) {
    let CREATE_PAYMENT_URL = process.env.REACT_APP_AUTOMAGIC_SERVER_HOST + '/api/payments/paypal/create'
    let jwtFromStorage = localStorage.getItem('automagic_token')
    // Make a call to our server to set up the payment
    return window.paypal.request.post(
      CREATE_PAYMENT_URL,
      {
        productID: productID
      },
      {
        headers: {
          'Authorization': `Bearer ${jwtFromStorage}`,
        }
      }
    )
    .then(res => {
      return Promise.resolve(res.paymentID)
    })
    .catch(error => {
      return Promise.reject(error)
    })
  }

  // The payment has been authorized, so call the back-end to complete the payment
  onAuthorize(data, actions, productID, logoToPurchase) {
    let EXECUTE_PAYMENT_URL = process.env.REACT_APP_AUTOMAGIC_SERVER_HOST + '/api/payments/paypal/execute'
    let jwtFromStorage = localStorage.getItem('automagic_token')
    // Make a call to our server to execute the payment
    return window.paypal.request.post(
      EXECUTE_PAYMENT_URL,
      {
        paymentToken: data.paymentToken,
        paymentID: data.paymentID,
        productID: productID,
        payerID: data.payerID,
        purchasedLogo: JSON.stringify(logoToPurchase)
      },
      {
        headers: {
          'Authorization': `Bearer ${jwtFromStorage}`
        }
      }
    )
    .then(res => {
      // Show a success page to the buyer
      return actions.redirect()
    })
    .catch(error => {
      if (error.message) {
        if (error.message.search('INSTRUMENT_DECLINED') > -1) {
          window.alert('The specified instrument was either declined by the processor or bank or it cannot be used for this payment.')
          return actions.restart()
        }
      }
      return Promise.reject(error)
    })
  }

  // Called if the buyer cancels the payment
  onCancel(data, actions) {
    // return actions.redirect()
  }

  // Called if an error occurs
  // Allow the buyer to re-try or show an error message
  onError(err) {
    // TODO: stop using window alert
    if (err.message) {
      if (err.message.search('STORE_DB') > -1) {
        return window.alert('Foi encontrado um erro ao efetuar o pagamento. Entre em contato com contato@cod.ai e não efetue o pagamento novamente!')
      }
    }
    return window.alert('Um erro foi encontrado. Por favor, tente novamente!')
  }

  faqSection(selectedLanguage) {
    return (
      <div className="download-section" id="faq-section">
        <h1>{ i18n[selectedLanguage]['faq-title'] }</h1>
        <div className="flex-row">
          <div className="col-4">
            <h2>{ i18n[selectedLanguage]['faq-question-register'] }</h2>
            <p>{ i18n[selectedLanguage]['faq-answer-register'] }</p>
          </div>
          <div className="col-4">
            <h2>{ i18n[selectedLanguage]['faq-question-unique'] }</h2>
            <p>{ i18n[selectedLanguage]['faq-answer-unique'] }</p>
          </div>
          <div className="col-4">
            <h2>{ i18n[selectedLanguage]['faq-question-same'] }</h2>
            <p>{ i18n[selectedLanguage]['faq-answer-same'] }</p>
          </div>
        </div>
        <div className="flex-row">
          <div className="col-4">
            <h2>{ i18n[selectedLanguage]['faq-question-receive'] }</h2>
            <p>{ i18n[selectedLanguage]['faq-answer-receive'] }</p>
          </div>
          <div className="col-4">
            <h2>{ i18n[selectedLanguage]['faq-question-couldnotfound'] }</h2>
            <p>{ i18n[selectedLanguage]['faq-answer-couldnotfound'] }</p>
          </div>
          <div className="col-4">
            <h2>{ i18n[selectedLanguage]['faq-question-refund'] }</h2>
            <p>{ i18n[selectedLanguage]['faq-answer-refund'] }</p>
          </div>
        </div>
        <div className="flex-row">
          <div className="col-4">
            <h2>{ i18n[selectedLanguage]['faq-question-freeshipping'] }</h2>
            <p>{ i18n[selectedLanguage]['faq-answer-freeshipping'] }</p>
          </div>
          <div className="col-4">
            <h2>{ i18n[selectedLanguage]['faq-question-printshipping'] }</h2>
            <p>{ i18n[selectedLanguage]['faq-answer-printshipping'] }</p>
          </div>
          <div className="col-4">
            <h2>{ i18n[selectedLanguage]['faq-question-paperquality'] }</h2>
            <p>{ i18n[selectedLanguage]['faq-answer-paperquality'] }</p>
          </div>
        </div>
        <div className="flex-row">
          <div className="col-4">
            <h2>{ i18n[selectedLanguage]['faq-question-nothome'] }</h2>
            <p>{ i18n[selectedLanguage]['faq-answer-nothome'] }</p>
          </div>
          <div className="col-4">
            <h2>{ i18n[selectedLanguage]['faq-question-editafter'] }</h2>
            <p>{ i18n[selectedLanguage]['faq-answer-editafter'] }</p>
          </div>
          <div className="col-4">
            <h2>{ i18n[selectedLanguage]['faq-question-digitalproduction'] }</h2>
            <p>{ i18n[selectedLanguage]['faq-answer-digitalproduction'] }</p>
          </div>
        </div>
        <div className="flex-row">
          <div className="col-4">
            <h2>{ i18n[selectedLanguage]['faq-question-paymentmethod'] }</h2>
            <p>{ i18n[selectedLanguage]['faq-answer-paymentmethod'] }</p>
          </div>
          <div className="col-4">
            <h2>{ i18n[selectedLanguage]['faq-question-safe'] }</h2>
            <p>{ i18n[selectedLanguage]['faq-answer-safe'] }</p>
          </div>
          <div className="col-4">
            <h2>{ i18n[selectedLanguage]['faq-question-fone'] }</h2>
            <p>{ i18n[selectedLanguage]['faq-answer-fone'] }</p>
          </div>
        </div>
        <div className="flex-row">
          <div className="col-4">
            <h2>{ i18n[selectedLanguage]['faq-question-office'] }</h2>
            <p>{ i18n[selectedLanguage]['faq-answer-office'] }</p>
          </div>
          <div className="col-4">
            <h2>{ i18n[selectedLanguage]['faq-question-mission'] }</h2>
            <p>{ i18n[selectedLanguage]['faq-answer-mission'] }</p>
          </div>
          <div className="col-4">
            <h2>{ i18n[selectedLanguage]['faq-question-morequestions'] }</h2>
            <p>{ i18n[selectedLanguage]['faq-answer-morequestions'] }</p>
          </div>
        </div>
      </div>
    )
  }

  render() {

    let { currentLogoPreview, userPrefs, availableLogoPreviews, availableEmotions, availableValues, availableColorPalettes, availableTypefaces } = this.props.newLogo
    if (!userPrefs || !availableLogoPreviews || !availableEmotions || !availableValues || !availableColorPalettes || !availableTypefaces) return null
    let { selectedEmotions, selectedValues, selectedColorPalettes, selectedTypefaces, selectedLanguage } = userPrefs
    let locale = 'en_US'
    if (selectedLanguage === 'pt') locale = 'pt_BR'
    let logoPreviews = availableLogoPreviews.payload
    if (!selectedEmotions || !selectedValues || !logoPreviews) return null
    // The true current logo preview selected by user is currentLogoPreview
    if (logoPreviews.length < 1) return null
    if (logoPreviews.length <= currentLogoPreview) return null
    let logoInfo = logoPreviews[currentLogoPreview]
    if (!logoInfo) return null

    let availableProducts = this.props.availableProducts
    console.log('availableProducts', availableProducts)
    if (!availableProducts) return null
    // if (!availableProducts) {
    //   return (
    //     <div>
    //       { this.faqSection(selectedLanguage) }
    //     </div>
    //   )
    // }
    if (availableProducts.length < 1) return null
    availableProducts.sort((a, b) => { return a.uid - b.uid })

    let discounts = {
      en: [0.5, 0.3, 0.3],
      pt: [0.5, 0.3, 0.3, 0.3, 0.3]
    }
    let currency = availableProducts[0].currency === 'BRL' ? 'R$' : '$'

    let logoToPurchase = {
      brandName: userPrefs.logoName,
      svg: {
        light: logoInfo.svg,
        dark: logoInfo.svgDark,
      },
      preferences: {}
    }
    if (userPrefs.brandSlogan) logoToPurchase.brandSlogan = userPrefs.brandSlogan
    // Prepare images to show on mockups
    let mockupLight
    if (logoInfo.canvas)
      mockupLight = logoInfo.canvas.toDataURL('image/png')
    // let mockupDark
    // if (logoInfo.canvasDark)
    //   mockupDark = logoInfo.canvasDark.toDataURL('image/png')

    let logoInfoClean = Object.assign({}, logoInfo)
    delete logoInfoClean.svg
    delete logoInfoClean.svgDark
    delete logoInfoClean.canvas
    delete logoInfoClean.canvasDark
    if (!userPrefs.brandSlogan) delete logoInfoClean.sloganTypeface

    logoToPurchase.elements = logoInfoClean
    logoToPurchase.preferences.emotions = availableEmotions.filter((emotion) => {
      return selectedEmotions.indexOf(emotion.uid) > -1
    })
    logoToPurchase.preferences.values = availableValues.filter((value) => {
      return selectedValues.indexOf(value.uid) > -1
    })
    logoToPurchase.preferences.colorPalettes = availableColorPalettes.filter((color) => {
      return selectedColorPalettes.indexOf(color.uid) > -1
    })
    logoToPurchase.preferences.typefaces = availableTypefaces.filter((typeface) => {
      return selectedTypefaces.indexOf(typeface.uid) > -1
    })
    logoToPurchase.preferences.selectedLanguage = userPrefs.selectedLanguage
    // logoToPurchase.preferences.images = userPrefs.selectedImages // Not used for now

    let colorBackground = logoToPurchase.elements.colorPalette.colorBackground

    let PayPalButton = window.paypal.Button.driver('react', { React, ReactDOM })
    let env = process.env.REACT_APP_PAYPAL_MODE || 'sandbox' // sandbox || production
    let commit = true // In the Pay Now experience, the payment occurs immediately after the buyer clicks the Pay Now button on the checkout page

    let paypalStyle = {
      size: "responsive",
      color: "gold", // gold | blue
      shape: "pill",
      label: 'buynow',
      fundingicons: true,
      branding: true,
    }

    // if (availableProducts && logoToPurchase) {
      let productsList = availableProducts.map((item) => {
        if (item.name === 'Logo') {
          if (this.props.authenticatedUser) {
            if (this.props.authenticatedUser.type) {
              if (this.props.authenticatedUser.type === "demo" ||
                  this.props.authenticatedUser.type === "free") {
                return (
                  <div className="paypal-wrapper" key="pay-wrapper">
                    <div className="paypal-button" key="pay-button">
                      <a className="free-button" onClick={ (evt) => { this.freePurchase(item.uid, logoToPurchase) } } >
                        { i18n[selectedLanguage]['buy-now-free'] }
                      </a>
                    </div>
                  </div>
                )
              }
            }
          }
        }

        return (
          <div className="paypal-wrapper" key="pay-wrapper">
            <div className="paypal-button" key="pay-button">
                  <PayPalButton
                   locale={locale}
                   style={paypalStyle}
                   payment={ (data) => this.payment(data, item.uid) }
                   commit={commit}
                   env={env}
                   onAuthorize={ (data, actions) => this.onAuthorize(data, actions, item.uid, logoToPurchase) }
                   onCancel={ (data, actions) => this.onCancel(data, actions) }
                   onError={ (err) => this.onError(err) }
                  />
            </div>
          </div>
        )
      })
    // }
    // if (!productsList) return null

    let plansColumns = availableProducts.map((product, index) => {
      let { name, amount } = product
      let discount = discounts[selectedLanguage][index]
      let { descriptions, subtitle } = i18n[selectedLanguage]["products"][name]

      // <div className="banner-price-hat"></div>
      // <h2><span className="price-currency">3x { currency }</span> { formatAmount(amount/3, 0, 0, false) }</h2>
      return (
        <div className="col-2 col-plan" key={index}>
          <div className="banner-price" id="banner-price-1">
            { (name === "Logo")
              ?
                <div className="on-sale"><div className="stripe-green">{i18n[selectedLanguage]['limited']}</div></div>
              :
                (name === "Cartão" || name === "Web")
                ?
                  <div className="on-sale"><div className="stripe-pink">{i18n[selectedLanguage]['new']}</div></div>
                :
                  <div className="on-sale-top"></div>
            }
            <h1><span className="plus-plan-name"></span>{ name }</h1>
            <span>
              <h3 className="original-price">{currency} {formatAmount(amount, discount, 0, true)}</h3>
              <h3 className="discount">{ i18n[selectedLanguage]['save'] } { discount * 100 }%</h3>
              <h2><span className="price-currency">{ currency }</span> { amount }</h2>
              <h3 className="discount-launch">{ i18n[selectedLanguage]['launch-price'] }</h3>
            </span>
            { productsList[index] }
          </div>

          <div className="banner-subtitle">
            { subtitle }
          </div>

          <ul className="about-list">
          {
            descriptions.map((desc, indexDesc) => {
              return (
                <li className="product-description" key={"desc-"+indexDesc}>{ desc }</li>
              )
            })
          }
          </ul>
        </div>
      )
    })

    return (
      <div className="">
        <div className="download-section">

          <div className="flex-row" style={{ alignItems: "flex-start" }}>

            <div className="col-6" style={{ paddingTop: "100px"}}>

              <svg viewBox="0 0 1024 615" preserveAspectRatio="xMidYMid meet" width="100%" height="100%">
                  <defs>
                    <linearGradient id="lgrad" x1="0%" y1="67%" x2="120%" y2="33%" >
                      <stop offset="52%" style={{ stopColor: colorBackground, stopOpacity: 1}} />
                      <stop offset="100%" style={{ stopColor: "rgb(255, 255, 255)", stopOpacity: 1}} />
                    </linearGradient>
                    <radialGradient id="rgrad" cx="50%" cy="50%" r="75%" >
                      <stop offset="32%" style={{ stopColor: "#ffffff", stopOpacity: 0 }} />
                      <stop offset="100%" style={{ stopColor: "#000000", stopOpacity: 0.1 }} />
                    </radialGradient>
                  </defs>
                  <rect
                    width="427"
                    height="230"
                    x="531"
                    y="145"
                    fill="url(#lgrad)"
                  />
                  <rect
                    width="427"
                    height="230"
                    x="531"
                    y="145"
                    fill="url(#rgrad)"
                  />
                 <image xlinkHref="download_page/download-hands2.png"
                     width="1024"
                     height="615"
                     x="0"
                     y="0"
                 ></image>
                  <image
                    xlinkHref={ mockupLight }
                    width="180"
                    height="180"
                    x="654"
                    y="170"
                    id="mockup-cards-placeholder2"
                  ></image>
              </svg>

              <h1>{ i18n[selectedLanguage]['step-download-title'] }</h1>
              <h2 style={{ paddingBottom: "20px"}}>{ i18n[selectedLanguage]['step-download-subtitle'] }</h2>

            </div>

            <div className="col-6" id="download-mockups" style={{ textAlign: "right" }}>
                  <svg viewBox="0 0 800 800" preserveAspectRatio="xMidYMid meet" width="100%" height="100%">
                    <linearGradient id="lgrad" x1="0%" y1="67%" x2="120%" y2="33%" >
                      <stop offset="52%" style={{ stopColor: colorBackground, stopOpacity: 0.8}} />
                      <stop offset="100%" style={{ stopColor: "rgb(255, 255, 255)", stopOpacity: 0}} />
                    </linearGradient>

                    <linearGradient id="lgrad2" x1="0%" y1="67%" x2="100%" y2="100%" >
                      <stop offset="52%" style={{ stopColor: colorBackground, stopOpacity: 0.6}} />
                      <stop offset="100%" style={{ stopColor: "rgb(255, 255, 255)", stopOpacity: 0}} />
                    </linearGradient>

                    <radialGradient id="rgrad" cx="50%" cy="50%" r="75%" >
                      <stop offset="32%" style={{ stopColor: colorBackground, stopOpacity: 1}} />
                      <stop offset="100%" style={{ stopColor: "#ffffff", stopOpacity: 0 }} />
                    </radialGradient>


                     <image xlinkHref="download_page/download-bag.jpg"
                         width="400"
                         height="400"
                         x="0"
                         y="0"
                     ></image>
                      <ellipse
                        rx="60"
                        ry="60"
                        cx="136"
                        cy="240"
                        fill="url(#lgrad)"
                      ></ellipse>
                      <image
                        xlinkHref={ mockupLight }
                        width="72"
                        height="72"
                        x="100"
                        y="204"
                        id="mockup-cards-placeholder1"
                      ></image>

                     <image xlinkHref="download_page/mockup-coffee.jpg"
                         width="400"
                         height="400"
                         x="400"
                         y="0"
                     ></image>
                      <image
                        xlinkHref={ mockupLight }
                        width="77"
                        height="77"
                        x="558"
                        y="152"
                        id="mockup-cards-placeholder2"
                      ></image>

                     <image xlinkHref="download_page/mockup-tshirt.jpg"
                         width="400"
                         height="400"
                         x="0"
                         y="400"
                     ></image>
                      <image
                        xlinkHref={ mockupLight }
                        width="126"
                        height="126"
                        x="134"
                        y="495"
                        id="mockup-cards-placeholder2"
                      ></image>

                     <image xlinkHref="download_page/mockup-wall.jpg"
                         width="400"
                         height="400"
                         x="400"
                         y="400"
                     ></image>
                      <rect
                        width="0"
                        height="0"
                        x="514"
                        y="506"
                        transform="matrix( 1,-0.2, 0.04, 1, -19, 122)"
                        fill="url(#lgrad2)"
                      ></rect>
                      <image
                        xlinkHref={ mockupLight }
                        width="140"
                        height="140"
                        x="528"
                        y="518"
                        transform="matrix( 1,-0.2, 0.04, 1, -19, 122)"
                        id="mockup-cards-placeholder2"
                      ></image>

                  </svg>

            </div>

          </div>

        </div>

        <div className="download-section" id="price-section" style={{ background: "transparent", padding: "20px 4.5em"}}>

          <div className="flex-row" style={{ justifyContent: "center", alignItems: "flex-start", padding: "20px"}}>

            { plansColumns }

          </div>

        </div>

        {this.faqSection(selectedLanguage)}

      </div>
    )
  }
}

export default LogoDownload



// WEBPACK FOOTER //
// ./src/components/LogoDownload.js